var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['exp-popup', _vm.open ? 'open' : '']},[_c('div',{staticClass:"exp-popup__container"},[_c('Close',{staticClass:"exp-popup__close",nativeOn:{"click":function($event){return _vm.closeFunction($event)}}}),_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }